import './game-cell.css';

export const GameCell = ({ name, thumbnail, isLoading, onClick }, context) => {
  return {
    render: () => ({
      div: {
        onClick: () => onClick?.(),
        className:
          'w-48 h-36 bg-blue-500 p-8 shadow-md rounded-2xl overflow-hidden flex flex-col items-center',
        children: [
          { img: { className: 'my-8', src: thumbnail, width: 150, height: 100, alt: name } },
          { h3: { text: name } },
          ...(isLoading?.()
            ? [
              {
                div: {
                  className: 'dim-view w-48 h-36 rounded-2xl',
                  children: [{ div: { className: 'loader' } }],
                },
              },
            ]
            : []),
          // { span: { className: 'loader', hidden: () => !isLoading?.() } }
        ],
      },
    }),
  };
};
